import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconHint: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="16" viewBox="0 0 16 16" width="16" {...props}>
        <path
            clipRule="evenodd"
            d="M8 0C3.588 0 0 3.588 0 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.933A6.94 6.94 0 011.067 8 6.941 6.941 0 018 1.067 6.94 6.94 0 0114.933 8 6.94 6.94 0 018 14.933z"
            fill="currentColor"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M7.067 4.475c0 .483.42.876.929.876.517 0 .937-.393.937-.876 0-.473-.421-.866-.937-.866-.508 0-.929.393-.929.866zm.4 2.494h1.067v4.978H7.467V6.969z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
